import * as appSyncHandlers from './appSync';
import { cognitoIdentityHandler, cognitoIDPHandler } from './cognito';

export const handlers = [
    ...Object.values(appSyncHandlers),
    cognitoIdentityHandler,
    cognitoIDPHandler,
];
